module.exports = __webpack_public_path__ + "img/LUB00009.21155a1f.png";